{
    "webshop_offer_voucher_correctCode": "Wprowadzono poprawny kod",
    "webShop_howToFindId_desc": "Swój identyfikator osobisty znajdziesz i skopiujesz na ekranie swojego profilu gracza.",
    "webShop_howToFindId_link": "Gdzie znajdę moje osobiste ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Kod jest niewłaściwy",
    "webshop_offer_voucher_enterYourCode": "Wprowadź swój identyfikator osobisty",
    "webShop_unexpectedError_desc": "Wystąpił nieoczekiwany błąd. Prosimy spróbować ponownie później.",
    "webShop_accountBanned_desc": "Konto zablokowane!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Warunki użytkowania",
    "webshop_purchase_privacyPolicy": "Ochrona danych osobowych",
    "webshop_legal_1": "Informacje prawne",
    "webshop_support_1": "Wsparcie",
    "mbs_access_welcome_desc": "Witaj, {0}!",
    "btn_login": "Logowanie",
    "mbs_access_error_sessionExpired_desc": "Sesja wygasła. Prosimy o ręczne wprowadzenie ID konta."
}
